module.exports = __webpack_public_path__ + "img/LATIN10_34.bd0c9762.jpg";